import * as oPath from '../../../Lib/Object/Path/Mutable';
import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions: sliceActions } = createSlice({
  name: 'environment',
  initialState: {
    data: {},
    status: {
      synchronising: false,
    },
  },
  reducers: {
    getEnvironmentData: (state) => {
      state.status.synchronising = true;
    },
    getEnvironmentDataResolve: (state, { payload: { data } = {} }) => {
      oPath.setMultiple(state, `data`, data);
      state.status.synchronising = false;
    },
    getEnvironmentDataReject: (state) => {
      state.status.synchronising = false;
    },
  },
});

export { reducer };
export const actions = { ...sliceActions };
